// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailViewAmenities_container__2yvvD","showMore":"DetailViewAmenities_showMore__DCKlc","heading":"DetailViewAmenities_heading__3XCcJ"};